import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import FullScreenDataContainer
  from 'Components/ComponentLibrary/Components/Uncategorized/DataContainer/FullScreenDataContainer';
import Content from './Content';
import { useSetNewPasswordContext } from './SetNewPasswordContext';

const styles = () => ({
  root: {},
});

const SetNewPasswordContainer = ({
  className,
  classes,
}) => {
  const {
    isInitializing,
    initializingError,
  } = useSetNewPasswordContext();

  return (
    <FullScreenDataContainer
      className={classes.container}
      component={Content}
      componentProps={{
        className: classNames(classes.root, className),
      }}
      loading={isInitializing}
      loadingError={initializingError}
    />
  );
};

SetNewPasswordContainer.defaultProps = {
  className: '',
};

SetNewPasswordContainer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SetNewPasswordContainer);
